<div class="dashboard-main container-fluid" *ngIf="loader" style="height: 550px;">
    <div class="loaderwrapper" style="z-index: 1024;">
        <span class="loader"></span>
    </div>
</div>
<section class="dashboard-main container-fluid" *ngIf="permissionsReady && permissions.canView && !loader">
    <div class="contents-main">
        <div class="card table-card mb-3">
            <!-- Title, filters and the page action share one row at the top
                 of the card rather than stacking above it. -->
            <div class="table-toolbar">
                <h1 class="table-toolbar__title">Monthly Report</h1>
                <div class="sb-filter-holder sb-filter-holder--inline">
                    <div class="input-wrapper">
                        <ng-select [items]="allPlantList" bindLabel="stationName" placeholder="Plant"
                            bindValue="stationCode" class="sb-filter-field sb-filter-field--md limit-ng-value"
                            (change)="selectPlants($event)">
                            <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                                <ng-container *ngFor="let item of items; let i = index">
                                    <div class="ng-value" *ngIf="i < 1">
                                        <span class="ng-value-label">{{ item.stationName }}</span>
                                        <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                                    </div>
                                </ng-container>
                                <div class="ng-value" *ngIf="items.length > 1">
                                    <!-- {{items.length - 1}} more -->
                                    <span class="ng-value-label">...</span>
                                </div>
                            </ng-template>
                        </ng-select>
                    </div>
                    <div class="input-wrapper daterange-wrapper">
                        <input type="text" class="sb-filter-field sb-filter-field--md" bsDatepicker
                            [(ngModel)]="selectedDate" [bsConfig]="datePickerConfig" #dp="bsDatepicker"
                            (ngModelChange)="onRangeChange($event)" placeholder="Month" />

                        <span class="sb-filter-date-icon" (click)="dp.toggle()">
                            <span><svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16"
                                    fill="none">
                                    <path
                                        d="M12.8046 1.60066H12.0042V0H10.4036V1.60066H4.00087V0H2.40021V1.60066H1.59987C1.39011 1.60066 1.18241 1.64213 0.988734 1.72268C0.795054 1.80324 0.619218 1.9213 0.471327 2.07006C0.323435 2.21882 0.206406 2.39535 0.126986 2.5895C0.0475649 2.78365 0.00731745 2.99157 0.00854826 3.20133L0.000549316 14.3993C0.000549316 14.8239 0.169189 15.231 0.469373 15.5312C0.769556 15.8314 1.17669 16 1.60121 16H12.7992C13.2237 16 13.6309 15.8314 13.9311 15.5312C14.2312 15.231 14.3999 14.8239 14.3999 14.3993V3.20133C14.3999 2.77773 14.232 2.37141 13.933 2.07138C13.6339 1.77135 13.2282 1.60208 12.8046 1.60066ZM12.8046 14.398H1.60655V5.59433H12.8046V14.398Z"
                                        fill="currentColor" />
                                </svg></span>
                        </span>
                    </div>
                </div>
                <button class="btn btn-dark rounded" (click)="downloadReport()">
                    <ng-container *ngIf="!isDownloading; else downloading">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
                            fill="none" class="me-2">
                            <path d="M10 1.5V14.5L14 10.1667" stroke="currentColor" stroke-width="1.5"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M10 14.5L5 10.5" stroke="currentColor" stroke-width="1.5"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M1 18.5H19" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg> Download Report
                    </ng-container>
                    <ng-template #downloading>
                        <span class="spinner-border spinner-border-sm me-2"></span> Downloading...
                    </ng-template>
                </button>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="table-header">
                    <h2 class="text-orange m-0">Monthly Production Report</h2>
                </div>
            </div>
            <div class="col-12 bg-white px-5 py-5 mb-3">
                <div class="row">
                    <div class="col-md-6">
                        <div class="table-wrap table-shadow">
                            <div class="table-main">
                                <table class="table-data text-center">
                                    <thead>
                                        <tr>
                                            <th colspan="2">SITE INFORMATION</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td width="50%">Client</td>
                                            <td>{{plantDetails?.header?.Client || '-'}}</td>
                                        </tr>
                                        <tr>
                                            <td>POC</td>
                                            <td>{{plantDetails?.header?.POC || '-'}}</td>
                                        </tr>
                                        <tr>
                                            <td>Contact</td>
                                            <td>{{plantDetails?.header?.Contact || '-'}}</td>
                                        </tr>
                                        <tr>
                                            <td>Commissioning Date</td>
                                            <td>{{plantDetails?.header?.CommissionDate || '-'}}</td>
                                        </tr>
                                        <tr>
                                            <td>Total PV Size</td>
                                            <td>{{plantDetails?.header?.TotalPVSize || '-'}}</td>
                                        </tr>
                                        <tr>
                                            <td>Total Selling Price </td>
                                            <td>{{plantDetails?.header?.TotalSellingPrice || '-'}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="table-wrap table-shadow">
                            <div class="table-main">
                                <table class="table-data text-center">
                                    <thead>
                                        <tr>
                                            <th colspan="2">DISCO INFORMATION</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td width="50%">Company</td>
                                            <td>{{plantDetails?.tariff?.TariffCompany || '-'}}</td>
                                        </tr>
                                        <tr>
                                            <td>Tariff Type</td>
                                            <td>{{plantDetails?.tariff?.TarrifType || '-'}}</td>
                                        </tr>
                                        <tr>
                                            <td>Tariff</td>
                                            <td>{{plantDetails?.tariff?.TariffRate || '-'}}</td>
                                        </tr>
                                        <tr>
                                            <td>G.S.T</td>
                                            <td>{{form.tax ? (form.tax + '%') :'-'}}</td>
                                        </tr>
                                        <tr>
                                            <td>Reading Date</td>
                                            <td>{{plantDetails?.tariff ? (today | date: 'd/M/yyyy') : '-'}}</td>
                                        </tr>
                                        <tr>
                                            <td>Days in Month</td>
                                            <td>{{plantDetails?.billing_period?.items?.length || '-'}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 bg-white px-5 py-5 mb-3">
                <h2 class="mb-3">
                    <span class="text-orange">Billing Period: </span>{{plantDetails?.tariff?.monthName}}
                </h2>
                <div class="table-wrap table-shadow">
                    <div class="table-main">
                        <table class="table-data text-center">
                            <thead>
                                <tr>
                                    <th>SR. NO.</th>
                                    <th>Date</th>
                                    <th>UNITS (KWH)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <ng-container *ngIf="plantDetails?.billing_period?.items?.length > 0; else noRow">
                                    <tr *ngFor="let row of plantDetails?.billing_period?.items;let i=index">
                                        <td>{{i+1}}</td>
                                        <td>{{(row.date | date: 'd/M/yyyy') || '-'}}</td>
                                        <td>{{row.pvyield || '-'}}</td>
                                    </tr>
                                </ng-container>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="table-wrap table-shadow mt-4 mb-5">
                    <div class="table-main text-center">
                        <table class="table-data table-bordered">
                            <tbody>
                                <tr>
                                    <td class="text-start cell-muted success" width="44%">Total Units (Kwh)</td>
                                    <td>{{plantDetails?.summary?.TotalUnits_kWh || '-'}}</td>
                                </tr>
                                <tr>
                                    <td class="text-start cell-muted danger">Specific Yield Without LS Loss</td>
                                    <td>{{plantDetails?.summary?.SpecificYield_Without_LS_Loss || '-'}}</td>
                                </tr>
                                <tr>
                                    <td class="text-start cell-muted danger">Specific Yield Adjusted for Loss </td>
                                    <td>{{plantDetails?.summary?.SpecificYield_Adjusted_for_Loss || '-'}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="table-wrap pt-3">
                    <h2 class="mb-3 text-orange">Daily Energy Generation</h2>
                    <ng-container *ngIf="billingChart; else noDataBlock">
                        <div class="chart-container">
                            <highcharts-chart [Highcharts]="Highcharts" [options]="billingChart"
                                style="width: 100%; height: 467px; display: block;">
                            </highcharts-chart>
                        </div>
                    </ng-container>

                    <ng-template #noDataBlock>
                        <div class="text-center text-muted mt-3">
                            No PV Yield data available for this period.
                        </div>
                    </ng-template>

                    <div class="table-main text-center py-5">
                        <table class="table-data  table-bordered">
                            <tbody>
                                <tr>
                                    <td class=" cell-muted" width="16%">Remarks</td>
                                    <td>{{plantDetails?.summary ? form.remarks : '-'}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="col-12 bg-white px-5 py-5 mb-3">
                <div class="row">
                    <div class="col-md-6">
                        <div class="table-wrap h-100 table-shadow">
                            <div class="table-main h-100">
                                <table class="table-data text-center h-100">
                                    <thead>
                                        <tr>
                                            <th colspan="2">ROI Calculations</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td width="50%">Monthly Savings (Energy)</td>
                                            <td>{{plantDetails?.roi?.MonthlySavings || '-'}}</td>
                                        </tr>
                                        <tr>
                                            <td>Monthly Savings inc. Tax</td>
                                            <td>{{plantDetails?.roi?.MonthlySavings_IncludingTax || '-'}}</td>
                                        </tr>
                                        <tr>
                                            <td>Lifetime Energy (Kwh)</td>
                                            <td>{{plantDetails?.roi?.LifetimeEnergy_kWh || '-'}}</td>
                                        </tr>
                                        <tr>
                                            <td>Total Accumulated Savings (Energy)</td>
                                            <td>{{plantDetails?.roi?.AccumulatedSavings || '-'}}</td>
                                        </tr>
                                        <tr>
                                            <td>Total Accumulated Savings inc. Tax</td>
                                            <td>{{plantDetails?.roi?.AccumulatedSavings_WithTax || '-'}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="table-wrap h-100 table-shadow">
                            <div class="table-main h-100">
                                <table class="table-data text-center h-100">
                                    <thead>
                                        <tr>
                                            <th>ROI Progress</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <ng-container *ngIf="roiChart; else noRoiDataBlock">
                                                    <highcharts-chart *ngIf="roiChart" [Highcharts]="Highcharts"
                                                        [options]="roiChart"
                                                        style="width: 100%; height: 284px; display: block;">
                                                    </highcharts-chart>
                                                </ng-container>

                                                <ng-template #noRoiDataBlock>
                                                    <div class="text-center text-muted my-4">
                                                        No ROI data available for this period.
                                                    </div>
                                                </ng-template>

                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 bg-white px-5 py-5 mb-3 print-only">
                <div class="table-wrap h-100 table-shadow table-bordered">
                    <div class="table-main h-100">
                        <table class="table-data text-center h-100">
                            <tbody>
                                <tr>
                                    <td>
                                        <div style="height: 60px"></div>
                                    </td>
                                    <td>
                                        <div style="height: 60px"></div>
                                    </td>
                                    <td>
                                        <div style="height: 60px"></div>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="cell-muted" width="33.33%">Designated Engineer</td>
                                    <td class="cell-muted">Contact</td>
                                    <td class="cell-muted">Signature</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <!-- <div class="mt-4">
                    <h2>Monthly Report Summary</h2>
                    <p>Client: {{plantDetails?.header?.Client}}</p>
                    <p>Station Code: {{plantDetails?.inputs?.stationCode}}</p>
                    <p>Year: {{plantDetails?.tariff?.year}}</p>
                    <p>Month: {{plantDetails?.tariff?.monthName}}</p>
                </div> -->
            </div>
        </div>
    </div>
</section>
<!-- NO VIEW PERMISSION (FULL PAGE) -->
<section *ngIf="permissionsReady && !permissions.canView && !loader" class="dashboard-main container-fluid bg-white">
    <div class="contents-main">
        <div class="row">
            <div class="col-12">
                <div class="empty-state text-center d-flex flex-column align-items-center justify-content-center py-5">
                    <i class="fa fa-lock fa-3x mb-3 text-muted"></i>
                    <h5 class="mb-2">Access Restricted</h5>
                    <p class="text-muted">
                        You don’t have permission to view this report.
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>
<ng-template #LoadingRow>
    <tr>
        <td colspan="100%">
            <div class="d-flex justify-content-center">
                <div class="spinner-border text-primary" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
        </td>
    </tr>
</ng-template>
<ng-template #noRow>
    <tr>
        <td colspan="100">
            <div class="fw-semibold text-center text-muted">
                No data found
            </div>
        </td>
    </tr>
</ng-template>

<ng-template #initialMessage>
    <tr>
        <td colspan="7" class="fw-semibold text-center text-muted">
            Please apply plant and date filter to view the report.
        </td>
    </tr>
</ng-template>
<ng-template #subscribeModal let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title">Report Subscription</h4>
        <button type="button" class="btn-close" (click)="d('Cross click'); resetSubscribeForm()" [disabled]="isSaving">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                <rect y="0.696289" width="24" height="24" rx="12" fill="white" />
                <path d="M6.99988 7.69653L12.0514 12.748L17.1029 7.69653" stroke="currentColor" stroke-width="1.6"
                    stroke-linecap="round" stroke-linejoin="round" />
                <path d="M6.99995 18.3679L12.0505 13.3164L17.1021 18.3679" stroke="currentColor" stroke-width="1.6"
                    stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </button>
    </div>

    <div class="modal-body">

        <!-- Loader -->
        <div *ngIf="isLoadingSubscription" class="d-flex justify-content-center align-items-center py-5">
            <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>

        <!-- Unsubscribe Confirm -->
        <div *ngIf="!isLoadingSubscription && showUnsubscribeConfirm" class="text-center py-3">
            <p class="mb-3">You will no longer receive emails for this report.</p>
            <div class="d-flex justify-content-center gap-2">
                <button class="btn btn-outline-dark" (click)="cancelUnsubscribe()">Cancel</button>
                <button class="btn btn-orange" (click)="unsubscribe()">Confirm Unsubscribe</button>
            </div>
        </div>

        <!-- Main Form -->
        <div *ngIf="!isLoadingSubscription && !showUnsubscribeConfirm" [formGroup]="subscribeForm">
            <div class="form-group type-2">
                <div class="row">

                    <div class="col-md-6 mb-2">
                        <label>Report Name</label>
                        <input type="text" class="form-control" value="Monthly Report" disabled>
                    </div>

                    <div class="col-md-6 mb-2">
                        <label>Frequency <span class="text-danger">*</span></label>
                        <ng-select [items]="frequencyOptions" bindLabel="label" bindValue="value"
                            formControlName="frequency" placeholder="Select Frequency" [clearable]="false">
                        </ng-select>
                    </div>
                    <!-- Custom Range -->
                    <ng-container *ngIf="subscribeForm.get('frequency').value === 'CUSTOM'">
                        <div class="col-md-12 mb-2">
                            <label>From Day <span class="text-danger">*</span></label>
                            <ng-select [items]="fromDayOptions" bindLabel="label" bindValue="value"
                                formControlName="from_day" placeholder="Select Day">
                            </ng-select>
                        </div>
                        <!-- <div class="col-md-6 mb-2">
                            <label>To Day <small class="text-muted">(auto)</small></label>
                            <input type="text" class="form-control" [value]="toDayValue ? toDayValue : '-'" disabled
                                style="background:#f0f0f0; cursor:not-allowed;">
                        </div> -->
                        <!-- <div class="col-md-6 mb-2">
                            <label>To Day <small class="text-muted">(auto, +30 days)</small></label>
                            <input type="text" class="form-control" [value]="toDayValue ? ('Day ' + toDayValue) : '-'"
                                disabled style="background:#f0f0f0; cursor:not-allowed;">
                        </div> -->
                        <div class="col-md-12" *ngIf="subscribeForm.get('from_day')?.value">
                            <div class="alert alert-info my-2 fs-13 p-2">
                                <small>
                                    The report will be delivered via email by the end of the selected timeframe.
                                    <!-- The report will be delivered via email by the end of
                                    Day {{ nextDeliveryDay }}. -->
                                </small>
                            </div>
                        </div>
                    </ng-container>
                    <!-- <ng-container *ngIf="subscribeForm.get('frequency').value === 'CUSTOM'">
                        <div class="col-md-6 mb-2">
                            <label>From Date <span class="text-danger">*</span></label>
                            <div class="form-group input-group daterange-wrapper mb-0">
                                <input type="text" class="form-control" bsDatepicker [bsConfig]="datePickerConfig2"
                                    [(ngModel)]="fromDate" [ngModelOptions]="{standalone: true}"
                                    (ngModelChange)="onFromDateChange($event)" #fromDp="bsDatepicker"
                                    placeholder="DD/MM/YYYY" />
                                <div class="input-group-append" (click)="fromDp.toggle()">
                                    <span>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16"
                                            viewBox="0 0 15 16" fill="none">
                                            <path
                                                d="M12.8046 1.60066H12.0042V0H10.4036V1.60066H4.00087V0H2.40021V1.60066H1.59987C1.39011 1.60066 1.18241 1.64213 0.988734 1.72268C0.795054 1.80324 0.619218 1.9213 0.471327 2.07006C0.323435 2.21882 0.206406 2.39535 0.126986 2.5895C0.0475649 2.78365 0.00731745 2.99157 0.00854826 3.20133L0.000549316 14.3993C0.000549316 14.8239 0.169189 15.231 0.469373 15.5312C0.769556 15.8314 1.17669 16 1.60121 16H12.7992C13.2237 16 13.6309 15.8314 13.9311 15.5312C14.2312 15.231 14.3999 14.8239 14.3999 14.3993V3.20133C14.3999 2.77773 14.232 2.37141 13.933 2.07138C13.6339 1.77135 13.2282 1.60208 12.8046 1.60066ZM12.8046 14.398H1.60655V5.59433H12.8046V14.398Z"
                                                fill="currentColor" />
                                        </svg>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6 mb-2">
                            <label>To Date <small class="text-muted">(auto)</small></label>
                            <div class="form-group input-group daterange-wrapper mb-0">
                                <input type="text" class="form-control" bsDatepicker [bsConfig]="datePickerConfig2"
                                    [(ngModel)]="toDate" [ngModelOptions]="{standalone: true}" #toDp="bsDatepicker"
                                    placeholder="DD/MM/YYYY" disabled />
                                <div class="input-group-append">
                                    <span>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16"
                                            viewBox="0 0 15 16" fill="none">
                                            <path
                                                d="M12.8046 1.60066H12.0042V0H10.4036V1.60066H4.00087V0H2.40021V1.60066H1.59987C1.39011 1.60066 1.18241 1.64213 0.988734 1.72268C0.795054 1.80324 0.619218 1.9213 0.471327 2.07006C0.323435 2.21882 0.206406 2.39535 0.126986 2.5895C0.0475649 2.78365 0.00731745 2.99157 0.00854826 3.20133L0.000549316 14.3993C0.000549316 14.8239 0.169189 15.231 0.469373 15.5312C0.769556 15.8314 1.17669 16 1.60121 16H12.7992C13.2237 16 13.6309 15.8314 13.9311 15.5312C14.2312 15.231 14.3999 14.8239 14.3999 14.3993V3.20133C14.3999 2.77773 14.232 2.37141 13.933 2.07138C13.6339 1.77135 13.2282 1.60208 12.8046 1.60066ZM12.8046 14.398H1.60655V5.59433H12.8046V14.398Z"
                                                fill="currentColor" />
                                        </svg>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </ng-container> -->

                    <div class="col-md-12 form-styles my-2">
                        <label>Plant <span class="text-danger">*</span></label>
                        <ng-select [items]="availablePlants" bindLabel="stationName" bindValue="id"
                            formControlName="plant" placeholder="Select Plant" [closeOnSelect]="true"
                            (change)="onPlantSelect($event)">
                        </ng-select>
                    </div>

                    <!-- Plant Configured -->
                    <div class="col-md-12 mt-2" *ngIf="subscribedPlants.length > 0">
                        <label>Plant Configured</label>
                        <div class="d-flex flex-wrap gap-2 mt-1 p-2 border rounded">
                            <div *ngFor="let plant of subscribedPlants"
                                class="d-flex align-items-center gap-1 px-2 py-1 rounded"
                                style="background:#f0f0f0; font-size:13px; font-weight:500; color:#333;">
                                {{ plant.stationName }}
                                <span (click)="removePlant(plant)"
                                    style="cursor:pointer; margin-left:6px; font-size:16px; line-height:1; color:#888;">
                                    &times;
                                </span>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>

    <div class="modal-footer no-bg" *ngIf="!isLoadingSubscription && !showUnsubscribeConfirm">
        <button type="button" class="btn btn-orange waves-effect waves-light"
            [disabled]="!existingSubscription || isLoadingSubscription || isSaving" (click)="confirmUnsubscribe()">
            Unsubscribe
        </button>
        <button type="button" class="btn btn-outline-dark" (click)="d('Cross click'); resetSubscribeForm()"
            [disabled]="isLoadingSubscription || isSaving">
            Cancel
        </button>
        <button type="button" class="btn btn-orange"
            [disabled]="subscribedPlants.length === 0|| isLoadingSubscription || isSaving"
            (click)="saveMonthlySubscription()">
            <ng-container *ngIf="!isSaving; else saving">Save</ng-container>
            <ng-template #saving>
                <span class="spinner-border spinner-border-sm me-2"></span> Saving...
            </ng-template>
        </button>
    </div>
</ng-template>